import { render, staticRenderFns } from "./UrunVariantMaliyetSatisFiyatItem.vue?vue&type=template&id=06e6f592&scoped=true"
import script from "./UrunVariantMaliyetSatisFiyatItem.vue?vue&type=script&lang=js"
export * from "./UrunVariantMaliyetSatisFiyatItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6f592",
  null
  
)

export default component.exports